module.exports = __webpack_public_path__ + "static/img/icon_timer.b4fcbba6.svg";